import { render } from "./U.vue?vue&type=template&id=3e3dea52"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/U.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3e3dea52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3e3dea52', __exports__)) {
    api.reload('3e3dea52', __exports__)
  }
  
  module.hot.accept("./U.vue?vue&type=template&id=3e3dea52", () => {
    api.rerender('3e3dea52', render)
  })

}


export default __exports__